import { BoxContainer, Container } from '@/components';
import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';
import { BenefitsInner } from './parts';

import { JSX } from 'react';
import { ProspectData } from '@/types/salesforce';
import styles from './styles.module.scss';

export type BenefitsProps = SliceComponentProps<
  Content.BenefitsSlice,
  ProspectData
>;

const Benefits = ({ slice, context }: BenefitsProps): JSX.Element => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      id={slice.id}
    >
      <BoxContainer styles={`${styles.container} ${styles[slice.variation]}`}>
        <Container>
          <BenefitsInner slice={slice} prospect={context} />
        </Container>
      </BoxContainer>
    </section>
  );
};

export default Benefits;
